import { render, staticRenderFns } from "./RequestShortItem.vue?vue&type=template&id=46964eb3&scoped=true&"
import script from "./RequestShortItem.vue?vue&type=script&lang=js&"
export * from "./RequestShortItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46964eb3",
  null
  
)

export default component.exports